const isSuccessStatus = status => status >= 200 && status < 300;

export const parseErrorMessage = data => {
  if (typeof data !== 'string') return data?.message || data?.errorMessage || data;
  try {
    const parsed = JSON.parse(data);
    return parsed?.message || parsed?.errorMessage || data;
  } catch (e) {
    // Not JSON: the body is the plain-text message itself.
    return data;
  }
};

// Preserve plain-text errors even when the server labels them application/json.
export const transformWithErrorBody = defaultTransforms => (data, headers, status) => (isSuccessStatus(status)
  ? defaultTransforms.reduce((result, transform) => transform(result, headers, status), data)
  : { errorMessage: parseErrorMessage(data), httpStatus: status });

// The global interceptor resolves most failures, so callers must reject them explicitly.
export const createRejectOnErrorStatus = $q => response =>
  (response && (response.httpStatus >= 400 || response.status >= 400) ? $q.reject(response) : response);
